import React from 'react';
import { Artwork } from '../../types';
import { ArtworkCard } from './ArtworkCard';
import { SkeletonCard } from '../common/Loader';

interface ArtworkGridProps {
  artworks: Artwork[];
  loading?: boolean;
}

export const ArtworkGrid: React.FC<ArtworkGridProps> = ({ artworks, loading }) => {
  if (loading) {
    return (
      <div className="grid grid-cols-2 gap-4">
        {[...Array(6)].map((_, i) => (
          <SkeletonCard key={i} />
        ))}
      </div>
    );
  }

  if (artworks.length === 0) {
    return (
      <div className="text-center py-12">
        <p className="text-gray-500">No artworks found</p>
      </div>
    );
  }

  return (
    <div className="grid grid-cols-2 gap-4">
      {artworks.map((artwork) => (
        <ArtworkCard key={artwork.id} artwork={artwork} />
      ))}
    </div>
  );
};